import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { CourtComponent } from 'src/app/modal/court/court.component';
import { CourtService } from 'src/app/service/common/court.service';

@Component({
  selector: 'app-courts',
  templateUrl: './courts.component.html',
  styleUrls: ['./courts.component.css']
})
export class CourtsComponent implements OnInit {

  private _sub : Subscription = new Subscription();
  selectedStatus : any;
  courts : any = null;
  displayedColumns: string[] = ['courtName', 'address', 'postcode','telephone', 'fax', 'email', 'dateAdded','addedBy', 'status', 'action'];
  datasource : MatTableDataSource<any>;
  @ViewChild(MatPaginator) set paginator(pager:MatPaginator) {
    if (pager) this.datasource.paginator = pager;
  }

  constructor(
    private courtService : CourtService,
    private dialog : MatDialog,
  ) { 
    this.datasource = new MatTableDataSource();
    this.selectedStatus = '1';
  }

  ngOnInit(): void {
    this.loadCourts();
  }


  loadCourts(){
    this._sub.add(
      this.courtService.getCourts(this.selectedStatus).subscribe(res=> {
        if(res.status == 'ok'){
          this.courts = res.data;
          this.datasource.data = this.courts;
          if(!this.datasource.paginator){
            this.datasource.paginator = this.paginator;
          }
          this.paginator.firstPage();
        }else{
          this.courts = null;
          this.datasource.data = [];
        }
      })
    )
  }


  applyFilter(filterValue) {
    this.datasource.filter = filterValue.trim().toLowerCase();

    if (this.datasource.paginator) {
      this.datasource.paginator.firstPage();
    }
  }

  openCourtModal(id){
    if(id == 0){
      id = null;
    }
    
    let config : MatDialogConfig = {
      width : '700px',
      data : {
        'id' : id
      }
    }

    this.dialog.open(CourtComponent, config).afterClosed().subscribe(res => {
      if(res){
        this.loadCourts();
      }
    })

  }

  OnDestroy(){
    this._sub.unsubscribe();
  }

}
